import classNames from "classnames";
import { SmallSearchBarSearchIcon } from "components/atoms/Icon";
import "./index.scss";

interface IProps {
  text: any;
  setText: any;
}

export const SmallSearchBar = ({ text, setText }: IProps) => {
  return (
    <div className={classNames("small-search-bar-wrapper")}>
      <div className="search-icon">
        <SmallSearchBarSearchIcon />
      </div>
      <div className="input-field">
        <input
          type="text"
          placeholder="Search"
          value={text}
          onChange={(event: any) => setText(event.target.value)}
        />
      </div>
    </div>
  );
};
